import { css } from '@emotion/react';
import { useNavigate } from 'react-router';
import { Col, colors, Content, Row, Title, Button, Icon } from 'common-components';
import { Space } from 'antd';
import { useAppTranslation } from '@hooks';

type HeaderPropsType = {
  projectName?: string
};

const Header = ({ projectName }: HeaderPropsType) => {
  const navigate = useNavigate();
  const { translate } = useAppTranslation();
  const texts = [
    {
      type: 'tablePageTitle',
      content: projectName,
    },
    {
      type: 'tablePageSubtitle',
      content: translate('contribution.subtitle'),
    },
  ];

  return (
    // @ts-ignore
    <Content>
      <Row
        justify={'space-between'}
        align={'top'}
        css={css`
          margin: 16px 0;
        `}
      >
        <Col>
          <Row justify={'center'} gutter={16} align={'middle'}>
            <Col>
              <Button
                size="sm"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <Icon icon="ArrowNarrowLeft" size={20} />
              </Button>
            </Col>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space key={`title-${text.content}-${index}`} align={'center'}>
                      <Title style={{ fontSize: 18, lineHeight: '28px', color: colors.gray700 }}>
                        {text.content}
                      </Title>
                    </Space>
                  );
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                );
              })}
            </Col>
          </Row>
        </Col>
      </Row>
    </Content>
  );
};

export default Header;
